import { AfterContentInit, AfterViewInit, Component, Input } from '@angular/core';
import { CompositeCondition, OrCondition } from '../models/composite-conditions.model';
import { ConditionDialogService } from './condition-dialog.service';

@Component({
  selector: 'composite-condition',
  templateUrl: 'composite-condition.html'
})
export class CompositeConditionComponent implements AfterContentInit, AfterViewInit {
  @Input() conditionModel: CompositeCondition;
  @Input() hideCompositeOperator: boolean = false;
  @Input() isRoot: boolean = false;
  operatorTextKey: string;
  checked: boolean = false;


  constructor(private conditionDialogService: ConditionDialogService) {
    this.operatorTextKey = 'NoOp';
  }

  ngAfterViewInit(): void {
    if (this.isRoot) {
      setTimeout(() => { this.conditionDialogService.initiateCheckValidityEvent(); });
    }
  }

  ngAfterContentInit(): void {
    if (this.conditionModel && this.conditionModel instanceof OrCondition) {
      this.operatorTextKey = 'COMMON.DIALOGS.CONDITIONS.OPERATOR_OR';
    } else {
      this.operatorTextKey = 'COMMON.DIALOGS.CONDITIONS.OPERATOR_AND';
    }
  }

  onConditionCheckedToggle(event: any) {
    if (this.checked) {
      this.conditionDialogService.removeConditionFromSelected(this.conditionModel);
    } else {
      this.conditionDialogService.addConditionToSelected(this.conditionModel);
    }

    this.checked = !this.checked;
  }
}

